import { render, staticRenderFns } from "./AppUserSideMenu.vue?vue&type=template&id=03ffd2b8"
import script from "./AppUserSideMenu.vue?vue&type=script&lang=js"
export * from "./AppUserSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ffd2b8')) {
      api.createRecord('03ffd2b8', component.options)
    } else {
      api.reload('03ffd2b8', component.options)
    }
    module.hot.accept("./AppUserSideMenu.vue?vue&type=template&id=03ffd2b8", function () {
      api.rerender('03ffd2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/AppUserSideMenu.vue"
export default component.exports